import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ThemeProvider,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import Input from "@mui/joy/Input";
import theme from "../../../themes/theme";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import "./StudentsPage.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import BASE_URL from "../../../config/api";
import { Avatar } from "@mui/material";
import { AppContext } from "../../../context/AppContext";
import { useParams } from "react-router";

export default function StudentsPage() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tasksStats, setTasksStats] = useState(null);
  const [attendanceStats, setAttendanceStats] = useState(null);
  const [image, setImage] = useState(null);

  const { token } = useContext(AppContext);
  const { courseId } = useParams();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(response.data);
      } catch (error) {}
    };

    if (token) fetchUsers();
  }, [token]);

  const admins = users.filter((e) => e.userRole === 1).length;
  const students = users.filter((e) => e.userRole === 0).length;

  const handleUserClick = async (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);

    try {
      const tasksResponse = await axios.get(
        `${BASE_URL}/courses/${courseId}/users/${user._id}/stats/tasks`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTasksStats(tasksResponse.data);
    } catch (error) {}

    try {
      const attendanceResponse = await axios.get(
        `${BASE_URL}/courses/${courseId}/users/${user._id}/stats/attendance`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAttendanceStats(attendanceResponse.data);
    } catch (error) {}
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
    setTasksStats(null);
    setAttendanceStats(null);
  };

  const fetchUserDetails = async (userId) => {
    try {
      if (userId) {
        const userDetailsResponse = await axios.get(
          `${BASE_URL}/users/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setImage(userDetailsResponse.data.imagePath);
      }
    } catch (error) {
      return null;
    }
  };

  const filteredStudents =
    users &&
    users.length > 0 &&
    users.filter(
      (user) =>
        user.userRole === 0 &&
        user.name &&
        user.surname &&
        `${user.name} ${user.surname}`
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
    );

  let completionPercentage;
  if (attendanceStats) {
    completionPercentage =
      (attendanceStats.attendedCount / attendanceStats.totalLessons) * 100;
  }

  let textStyle = "user-info-text";
  if (completionPercentage < 50) {
    textStyle += " orange-text";
  } else if (completionPercentage >= 50 && completionPercentage < 75) {
    textStyle += " yellowish-text";
  } else {
    textStyle += " green-text";
  }

  return (
    <AdminLayout>
      <div className="users">
        <div className="users-header">
          <p className="title">Users </p>
          <div className="options">
            <div className="admins">Admins: {admins}</div>
            <div className="admins">Students: {students}</div>

            <div className="search">
              <Input
                variant="soft"
                placeholder="Search students"
                sx={{ width: "100%", maxWidth: "300px" }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <ThemeProvider theme={theme}>
                <Button variant="contained" sx={{ padding: "0px -2px" }}>
                  <SearchIcon />
                </Button>
              </ThemeProvider>
            </div>
          </div>
        </div>
        <TableContainer component={Paper}>
          <Table sx={{ maxWidth: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell>Full Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>City</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(filteredStudents) &&
                filteredStudents.map((user) => (
                  <TableRow
                    key={user._id}
                    onClick={() => {
                      handleUserClick(user);
                      fetchUserDetails(user._id);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>
                      {user.name && user.surname
                        ? `${user.name} ${user.surname}`
                        : "N/A"}
                    </TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>Student</TableCell>
                    <TableCell>{user.city}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={isModalOpen}
          onClose={handleCloseModal}
          PaperProps={{ sx: { padding: "10px" } }}
        >
          <DialogTitle>
            <div className="user-modal">
              <Avatar
                alt={(selectedUser && selectedUser.name) || ""}
                src={`${BASE_URL}${image}`}
              />
              <p className="title">
                {(selectedUser && selectedUser.name) || ""}{" "}
                {(selectedUser && selectedUser.surname) || ""} details
              </p>
            </div>
          </DialogTitle>
          <DialogContent className="user-info-modal" sx={{ padding: "5px" }}>
            {selectedUser && (
              <div>
                <div className="modal-box">
                  <p className="user-info-title">
                    Full Name: {selectedUser.name} {selectedUser.surname}
                  </p>

                  <p className="user-info-title">Email: {selectedUser.email}</p>
                </div>
                <p className="user-info-title">
                  Created at:
                  {selectedUser.createdAt
                    ? new Date(selectedUser.createdAt).toLocaleString()
                    : "N/A"}
                </p>
                {tasksStats && (
                  <>
                    <p className="user-info-label">Task Submitted:</p>
                    <p className="user-info-text">
                      {tasksStats.submittedCount}
                    </p>
                  </>
                )}

                {attendanceStats && (
                  <>
                    <p className="user-info-label">Lessons Attended:</p>
                    <p className={textStyle}>
                      {attendanceStats.attendedCount}/
                      {attendanceStats.totalLessons}
                    </p>
                  </>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <Button variant="outlined" onClick={handleCloseModal}>
                Close
              </Button>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
      </div>
    </AdminLayout>
  );
}
